












import { inject, injectable } from "inversify";
import { ErrorCode, ErrorSeverity, ThrowErrorFunction, throwErrorRTTI } from "~/modules/error";
import { httpAdapterRTTI } from "~/backend/backend.rtti";
import { HttpAdapter } from "~/backend/HttpAdapter/HttpAdapter";
import { AuthenticationMethod } from "~/backend/HttpAdapter/authenticationMethods";
import { convertDateStringValuesToDate } from "~/utils/processHttpAdapterResponse";
import { extractFileNameFromPath } from "~/utils/extractFromPath";

import { FeaturesConfig } from "../model/featuresConfig";

import { FeaturesService } from "./features.serviceInterface";

@injectable()
export class FeaturesServiceImpl implements FeaturesService {
    private httpAdapter: HttpAdapter;

    readonly #throwError: ThrowErrorFunction;

    constructor(
        @inject(httpAdapterRTTI) httpAdapter: HttpAdapter,
        @inject(throwErrorRTTI) throwError: ThrowErrorFunction
    ) {
        this.httpAdapter = httpAdapter;
        this.#throwError = throwError;
    }

    




    public async fetchFeatures(): Promise<FeaturesConfig> {
        const response = await this.httpAdapter.get<FeaturesConfig>(
            `https://flex[environment].twilio.com/api/v1/Session`,
            AuthenticationMethod.HostedFlex
        );
        const processedResponse = convertDateStringValuesToDate<FeaturesConfig>(response);
        return processedResponse;
    }
}
